module.exports = __webpack_public_path__ + "static/media/HelenLabs.b1777c2f.png";